import React, { useMemo, useState } from 'react';

import {
    AccessInfo,
    AgeGroup,
    CardControlLoader,
    CardRule,
    Piwik,
    RegionRule,
    RegionWarning,
    SiteCoreDictionary,
} from '../../types';
import RegionToggle from './RegionToggle';

interface RegionToggleListProps {
    cardControlLoader: CardControlLoader;
    cardRule: CardRule;
    handleRegionRuleChange: (regionId: string, enabled: boolean) => void;
    accessInfo: AccessInfo;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

export default (props: RegionToggleListProps) => {
    const [warning, setWarning] = useState<RegionWarning | null>(null);

    const { regions } = props.cardRule;
    const { regionWarningScandinaviaDisable } = props.dictionary;
    const { userAgeGroup, userIsHighFraudRisk } = props.accessInfo;
    const { isPostingCardControl, isFetchingCardControl } = props.cardControlLoader;

    const [, scandinavia, europe, africa, asia, northAmerica, southAmerica, oceania] = regions;

    const formDisabled = useMemo(
        () => userAgeGroup !== AgeGroup.ADULT || isPostingCardControl || isFetchingCardControl || userIsHighFraudRisk,
        [isPostingCardControl, isFetchingCardControl, userAgeGroup, userIsHighFraudRisk],
    );

    const updateEnabledRegions = ({ region: selectedRegion }: RegionRule, enabled: boolean) => {
        if (formDisabled) {
            return;
        }

        if (selectedRegion.id === scandinavia.region.id && !enabled) {
            if (europe.enabled) {
                setWarning({ region: selectedRegion, warningMessage: regionWarningScandinaviaDisable });
                return;
            }

            setWarning(null);
        }

        props.handleRegionRuleChange(selectedRegion.id, enabled);
    };

    return (
        <>
            {[europe, scandinavia, africa, asia, northAmerica, southAmerica, oceania].map((region) => (
                <RegionToggle
                    key={region.region.id}
                    regionRule={region}
                    warning={warning}
                    updateEnabledRegions={updateEnabledRegions}
                    {...props}
                />
            ))}
        </>
    );
};
